import { forwardRef, useMemo } from 'react'
import CheckedContainer from '../Input/types'
import { StyledCheckbox } from './styles'
import { CheckboxProps } from './props'

const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(
    ({ error, id, ...props }, ref) => {
        const generatedId = useMemo(
            () => id ?? `rr-checkbox-${Math.random().toString(36).slice(2)}`,
            [id]
        )

        return (
            <CheckedContainer
                {...props}
                id={generatedId}
                ref={ref}
                type="checkbox"
            >
                <StyledCheckbox error={error} htmlFor={generatedId} />
            </CheckedContainer>
        )
    }
)

Checkbox.displayName = 'Checkbox'

export default Checkbox

export { StyledCheckbox }
